import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NgBlocklyComponent } from './ng-blockly.component';
import { NgToolboxBuilderService } from './services/ng-toolbox-builder.service';

@NgModule({
    declarations: [NgBlocklyComponent],
    imports: [],
    exports: [NgBlocklyComponent],
    providers: [NgToolboxBuilderService],
    schemas: [NO_ERRORS_SCHEMA]
})
export class NgBlocklyModule {
  constructor() {
  }
}
